<script>

import VueSmoothScroll from 'vue2-smooth-scroll';


export default {

  name: 'quick-response',
  props: ['signed-parameters', 'token', 'id'],  
  components: {"vue-smooth-scroll": VueSmoothScroll},
  //mixins: [catalog],
  //template: '#location',
  data: function(){

      return {
        quicks:[],
        pageQuicks:1,
        siteId:"s1",
        reviewsGroup:[],
        pagination:{},
        order:"popular",
        show:false
      }
  },  
  mounted: function () {

   // console.log(this.id);
    this.getQuicks();
    
   
  },
  methods: {


    showQuick: function()
    {
      this.show = !this.show;
    },

    getQuicks : function(){


        let vue = this;
        let params_query = new URLSearchParams({
                                        mode: "class",
                                        nav_feed: "page-"+this.pageQuicks,
                                        c: "vue:one_element",
                                        action:"getQuickAnswer",
                                });

                                $.ajax({
                                    type: "POST",
                                    url: "/bitrix/services/main/ajax.php?"+params_query.toString(),
                                    data: {id: this.id, signedParameters: this.signedParameters, page: this.pageFeedbacks, order: this.order},
                                    headers: {'x-bitrix-csrf-token': this.token,
                                             'x-bitrix-site-id': this.sideId },
                                    //dataType: "dataType",
                                    success: function (response) {

                                        if (response.status === 'success') {

                                            vue.quicks = response.data.data;
                                            // vue.reviewsGroup = response.data.feed_stat;
                                            // vue.pagination = response.data.nav;

                                            // const myEl = document.getElementById("feedbacks");

                                            // vue.$smoothScroll({
                                            // scrollTo: myEl,
                                            // //hash: '#sampleHash'  // required if updateHistory is true
                                            // });
                                            //console.log(response.data.data);

                                        }
                                        //console.log(response);
                                    }
                                });
    },

  


  }

}



</script>
<style>
.one-quick {
    margin-bottom: 40px;
}

.title-quick {
    margin-bottom: 15px;
}
.title-text {
  font-weight: 600;
}
.date {
    color: #888888;
    font-size: 14px;
}

.requests {
    padding-left: 40px;
    margin-bottom: 15px;
}

.one-request {
    margin: 30px 0;
}

#catalogElement #reviews .controls, .quickstations .controls {
    background: #f4f4f4;
    text-align: center;
    margin-top: 24px;
    line-height: 35px;
    width: 260px;
    height: 35px;
}

#catalogElement #reviews .controls .good, .quickstations .controls .good {
    color: #009E02;
    margin-right: 4px;
}

</style>
<template>

   <div  id="catalogQuickstations" v-if="quicks.QUICKS && quicks.QUICKS.length > 0" >
        <div class="question-tab-h">
           Вопросы о товаре <span class="count-question-tab-h"> {{quicks.QUICKS.length}} </span>
         </div>
         <div class="quickstations" :class="{'hide-q':show }">
          <div class="question-tab-item" v-if="quicks" v-for="quick in quicks.QUICKS"> 
                                              
                                                  <div class="question-tab-item-h">
                                                      
                                                  </div>
                                                  
                                              <div class="question-tab-fl">
                                                  <div class="question-tab-user-name-sel">
                                                    {{quick.UF_NAME}}
                                                  </div>
                                                  <div class="question-tab-item-date">
                                                    {{quick.UF_DATE}}
                                                  </div>
                                              </div>
                                              <div class="question-tab-user-sel-discr">
                                                {{quick.UF_QUICK}}
                                              </div>
                                              

                                      <div class="question-tab-user-sel" v-for="response in quick.RESPONSES">
                                                      <div class="question-tab-fl-sel">
                                                          <div class="question-tab-user-name-sel">
                                                                {{response.UF_NAME}}
                                                          </div>
                                                          <div class="question-tab-item-date">
                                                            {{response.UF_DATE}}	
                                                          </div>
                                                      </div>
                                                      <div class="question-tab-user-sel-discr">
                                                        {{response.UF_TEXT}}	
                                                      </div>

                                                      <!-- <div class="question-tab-feed-sel">
                                                          Этот ответ полезен?
                                                          <div class="question-tab-feed-sel-like-dis">
                                                              <div class="question-tab-feed-sel-like">
                                                                  Да 1
                                                              </div>
                                                              <div class="question-tab-feed-sel-like">
                                                                  Нет 0
                                                              </div>
                                                          </div>
                                                      </div> -->
                                                    
                                        </div>
          </div>
        </div>

        <div class="show-more-question" @click="showQuick" :class="{'hide-b':!show}">
                                                    <span v-if="!show">Показать больше вопросов</span>
                                                    <span v-if="show">Скрыть вопросы</span>
                                                </div>
        
  </div>     
</template>